import { render, staticRenderFns } from "./ClipboardItemPositionControls.vue?vue&type=template&id=269c55bc&"
import script from "./ClipboardItemPositionControls.vue?vue&type=script&lang=js&"
export * from "./ClipboardItemPositionControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports